import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import MessageAlertModal from "./ModalTypes/MessageAlertModal";
import MessageRecordLockedModal from "./ModalTypes/MessageRecordLockedModal";
import MessageArchiveRecordLockedModal from "./ModalTypes/MessageArchiveRecordLockedModal";
import ModalButtons from "../ModalButtons/ModalButtons";

export default class MessageModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  render() {
    return (
      <div>
        {this.renderMessage()}
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons
          buttons={this.setButtons()}
          size="small"
          loading={this.state.loading}
        />
      </div>
    );
  }

  renderMessage() {
    switch (true) {
      case this.props.message_type === "alert":
        return <MessageAlertModal {...this.props} />;
      case this.props.message_type === "record_locked":
        return <MessageRecordLockedModal {...this.props} />;
      case this.props.message_type === "archive_record_locked":
        return <MessageArchiveRecordLockedModal {...this.props} />;
    }
  }

  setButtons() {
    if (this.props.message_type === "alert") {
      if (this.props.submit_endpoint || this.props.ok_to_archive == true) {
        return [
          {
            name: I18n.t("cancel"),
            html_attributes: ['data-dismiss="modal"'],
          },
          {
            name: I18n.t("submit"),
            button_classes: ["primary"],
            onClick: (e) => {
              this.setState({ loading: true });
              this.submit();
              return false;
            },
          },
        ];
      } else {
        return [
          {
            name: I18n.t("ok"),
            html_attributes: ['data-dismiss="modal"'],
          },
        ];
      }
    } else if (
      this.props.message_type === "record_lock" ||
      "archive_record_locked"
    ) {
      return [
        {
          name: I18n.t("ok"),
          html_attributes: ['data-dismiss="modal"'],
        },
      ];
    };
  };

  submit() {
    $.ajax({
      type: "POST",
      url: this.props.submit_endpoint,
    }).done((data) => {
      if (parent && parent.refresh_data) {
        if (this.props.show_dismiss_notification_translation == true) {
          parent.refresh_data(I18n.t("dismiss_saved_successfully"));
        } else if (data && data.success) {
          parent.refresh_data(data.success);
        } else {
          parent.refresh_data(this.props.archive_success_message != false ? this.props.archive_success_message : I18n.t("success"));
        }
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    });
  };
};
